import { render, staticRenderFns } from "./VoucherInfo.vue?vue&type=template&id=1399d685&scoped=true&"
import script from "./VoucherInfo.vue?vue&type=script&lang=ts&"
export * from "./VoucherInfo.vue?vue&type=script&lang=ts&"
import style0 from "./VoucherInfo.vue?vue&type=style&index=0&id=1399d685&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1399d685",
  null
  
)

export default component.exports